var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-checkable-tag',_vm._b({attrs:{"checked":_vm.checked},on:{"change":_vm.change}},'a-checkable-tag',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }